var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"align-center justify-center base-badge",class:( _obj = {}, _obj[("base-badge--is-" + _vm.size)] = true, _obj )},[_vm._v(" v"+_vm._s(_vm.id)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }